// extracted by mini-css-extract-plugin
export default {"wrapper":"_41bf2b7f"};